import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";

export default function Reports() {
  const [data, setData] = useState(null);
  const [outlets, setOutlets] = useState([]);
  const [outletId, setOutletId] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  const load = async () => {
    const params = {};
    if (outletId) params.outlet_id = outletId;
    if (start) params.start = start;
    if (end) params.end = end;
    const r = await api.get("/reports/summary", { params });
    setData(r.data);
  };
  useEffect(() => { (async () => { setOutlets((await api.get("/outlets")).data); })(); }, []);
  useEffect(() => { load(); }, [outletId, start, end]);

  const maxRev = (data?.by_day || []).reduce((m, d) => Math.max(m, d.revenue), 1);

  return (
    <div className="p-6 lg:p-10">
      <div className="mb-6">
        <div className="overline text-zinc-500">ANALITIK</div>
        <h1 className="font-display font-black text-4xl tracking-tighter">Laporan</h1>
      </div>
      <div className="flex flex-wrap gap-3 mb-6">
        <select data-testid="report-outlet" value={outletId} onChange={(e)=>setOutletId(e.target.value)} className="border border-border px-3 py-2 text-sm">
          <option value="">Semua Outlet</option>{outlets.map(o=><option key={o.id} value={o.id}>{o.name}</option>)}
        </select>
        <input data-testid="report-start" type="date" value={start.slice(0,10)} onChange={(e)=>setStart(e.target.value)} className="border border-border px-3 py-2 text-sm"/>
        <input data-testid="report-end" type="date" value={end.slice(0,10)} onChange={(e)=>setEnd(e.target.value? e.target.value + "T23:59:59" : "")} className="border border-border px-3 py-2 text-sm"/>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-5 grid-borders mb-8">
        {[
          { l: "Pendapatan", v: formatIDR(data?.revenue||0) },
          { l: "HPP / COGS", v: formatIDR(data?.cogs||0) },
          { l: "Laba Kotor", v: formatIDR((data?.revenue||0)-(data?.cogs||0)), color:"text-emerald-700" },
          { l: "Total Pembelian", v: formatIDR(data?.purchase_total||0) },
          { l: "Transaksi", v: (data?.tx_count||0) },
        ].map((s) => (
          <div key={s.l} className="p-5 bg-white">
            <div className="overline text-zinc-500">{s.l}</div>
            <div className={"mt-2 font-display font-black text-2xl lg:text-3xl tabular-nums " + (s.color||"")} data-testid={`rep-${s.l.toLowerCase().replace(/\s+/g,"-")}`}>{s.v}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-3 gap-0 grid-borders">
        <div className="lg:col-span-2 p-6 bg-white">
          <div className="overline text-zinc-500 mb-4">PENDAPATAN HARIAN</div>
          {data?.by_day?.length ? (
            <div className="space-y-2">
              {data.by_day.map((d) => (
                <div key={d.day} className="flex items-center gap-3">
                  <div className="w-24 text-xs font-mono">{d.day}</div>
                  <div className="flex-1 h-6 bg-zinc-100 relative">
                    <div className="absolute inset-y-0 left-0 bg-[#002FA7]" style={{ width: `${(d.revenue/maxRev)*100}%` }} />
                  </div>
                  <div className="w-28 text-right text-xs tabular-nums">{formatIDR(d.revenue)}</div>
                  <div className="w-16 text-right text-xs text-zinc-500 tabular-nums">{d.tx}x</div>
                </div>
              ))}
            </div>
          ) : <div className="text-sm text-zinc-500">Tidak ada data</div>}
        </div>
        <div className="p-6 bg-white">
          <div className="overline text-zinc-500 mb-4">METODE BAYAR</div>
          <div className="space-y-3">
            {Object.entries(data?.by_method || {}).map(([k, v]) => (
              <div key={k}>
                <div className="flex justify-between text-sm font-semibold uppercase"><span>{k}</span><span className="tabular-nums">{formatIDR(v)}</span></div>
                <div className="h-2 bg-zinc-100 mt-1"><div className="h-full bg-zinc-900" style={{width: `${(v/(data?.revenue||1))*100}%`}}/></div>
              </div>
            ))}
          </div>
          <div className="overline text-zinc-500 mt-8 mb-4">TOP PRODUK</div>
          <div className="space-y-2">
            {(data?.top_products||[]).slice(0,5).map((p, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className="font-display font-black w-5 text-zinc-400 tabular-nums">{i+1}</div>
                <div className="flex-1 text-sm truncate">{p.name}</div>
                <div className="text-xs tabular-nums">{formatIDR(p.revenue)}</div>
              </div>
            ))}
            {(data?.top_products||[]).length===0 && <div className="text-xs text-zinc-500">—</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
